// Module
var code = "<p> <label>Switch Index</label> <input type=\"range\" min=\"0\" max=\"2\" step=\"1\" value=\"0\" oninput=\"switch1.p.input.set(event.target.value)\"> </p>";
// Exports
export default code;